interface HomeWidgetRedDotStorage {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
}

const RED_DOT_STORAGE_PREFIX = "homeWidget:redDotSeen";
const RED_DOT_EXCLUDED_KEYS = new Set(["weeklyJackpot"]);

const getStorageKey = (itemKey: string): string => {
  return `${RED_DOT_STORAGE_PREFIX}:${itemKey}`;
};

export const getHomeWidgetRedDotDate = (date = new Date()): string => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getHomeWidgetRedDotStorage = ():
  | HomeWidgetRedDotStorage
  | null => {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

export const isHomeWidgetRedDotVisible = (
  itemKey: string,
  storage: HomeWidgetRedDotStorage | null = getHomeWidgetRedDotStorage(),
  date = new Date()
): boolean => {
  if (RED_DOT_EXCLUDED_KEYS.has(itemKey) || !storage) {
    return false;
  }

  return storage.getItem(getStorageKey(itemKey)) !== getHomeWidgetRedDotDate(date);
};

export const markHomeWidgetRedDotSeen = (
  itemKey: string,
  storage: HomeWidgetRedDotStorage | null = getHomeWidgetRedDotStorage(),
  date = new Date()
): void => {
  if (RED_DOT_EXCLUDED_KEYS.has(itemKey) || !storage) {
    return;
  }

  storage.setItem(getStorageKey(itemKey), getHomeWidgetRedDotDate(date));
};
